import { ToraxHttp } from '../../utils/custom-http.svc';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AssistancesData } from '../assistances.data';
import { Assistance } from './assistance';

@Component({

	selector: 'assistance-details',
	templateUrl: './assistance-details.tmpl.html'
})

export class AssistanceDetails implements OnInit {
	constructor(
		private assistancesData: AssistancesData,
		private toraxHttp: ToraxHttp,
		private activatedRoute: ActivatedRoute
	) {

		this.toraxHttp.updatedEvent.subscribe((id) => {
			if (id > 0 && this.assistance && id === this.assistance.assistanceID) {
				this.loadAssistance();
			}
		});
	}


	public assistance: Assistance;
	private id: number;


	public createAndPrintAssistanceLetter(): void {
		this.assistancesData.createAndPrintAssistanceLetter(this.id)
			.subscribe(data => {
					let popupWinindow: any = window.open('', '_blank', 'scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
					popupWinindow.document.open();
					popupWinindow.document.write('<html><head><style type="text/css">.MsoNormal { margin-top: 0px; margin-bottom: 0px;} @page { size: letter; margin: 0; } @media print { } </style></head><body  onload="window.print()"><div>' + (<any>data).value + '</div></body></html>');
					popupWinindow.document.close();
			});
	};


	public loadAssistance(): void {
		this.assistancesData.get(this.id)
			.subscribe((c:any) => this.assistance = c);
	}

	ngOnInit(): void {
		this.activatedRoute.params.forEach((params: Params) => {
			this.id = + params['assistanceID'];
			this.loadAssistance();
		});
	}
}
